<template>
  <div class="dilution-instructions">
    <div class="section-image">
      <b-container>
        <b-row>
          <b-col>
            <h1 class="text-center section-name">SPÄDNING</h1>
          </b-col>
        </b-row>
      </b-container>
    </div>
    <b-container class="view-container text-center">
      <b-row v-if="user.isAdmin">
        <b-col sm="12">
          <mu-raised-button
            class="demo-raised-button"
            label="Ta bort"
            icon="remove"
            primary
            @click="openConfirmDialog"
          />
          <mu-raised-button
            class="demo-raised-button"
            :label="instruction.isPublished ? 'Avpublicera' : 'Publicera'"
            :icon="instruction.isPublished ? 'visibility_off' : 'visibility'"
            :backgroundColor="instruction.isPublished ? 'gray' : 'green'"
            primary
            @click="togglePublish"
          />
          <hr />
        </b-col>
      </b-row>
      <div class="name-info">
        <b-row>
          <b-col sm="12">
            <h1 :class="{'low-margin-bottom': user.isAdmin}">
              <editor
                :areaKey="'name'"
                v-model="instruction.name"
                :editable="user.isAdmin"
                :applyTextEditCallback="applyTextEdit"
                emptyLabel="[Läkemedelsnamn]"
              ></editor>
            </h1>
          </b-col>
        </b-row>
        <b-row v-if="user.isAdmin">
          <b-col sm="12">
            <small class="npl-title">NPL-id:</small>
            <p class="npl-id">
              <editor
                :areaKey="'nplId'"
                v-model="instruction.nplId"
                :editable="user.isAdmin"
                :applyTextEditCallback="applyTextEdit"
                emptyLabel="[NPL-id]"
              ></editor>
            </p>
          </b-col>
        </b-row>
      </div>
      <hr />
      <div class="quick-info">
        <b-row class="justify-content-md-center">
          <b-col cols="3" class="text-right">
            <img
              v-b-tooltip.hover.auto
              title="Doseringsform"
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjBweCIgeT0iMHB4IgogICAgIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCIKICAgICB2aWV3Qm94PSIwIDAgNTAgNTAiCiAgICAgc3R5bGU9IjtmaWxsOiMwMDAwMDA7IgogICAgIGNsYXNzPSJpY29uIGljb25zOC1sYWItaXRlbXMiPiAgICA8cGF0aCBzdHlsZT0ibGluZS1oZWlnaHQ6bm9ybWFsO3RleHQtaW5kZW50OjA7dGV4dC1hbGlnbjpzdGFydDt0ZXh0LWRlY29yYXRpb24tbGluZTpub25lO3RleHQtZGVjb3JhdGlvbi1zdHlsZTpzb2xpZDt0ZXh0LWRlY29yYXRpb24tY29sb3I6IzAwMDt0ZXh0LXRyYW5zZm9ybTpub25lO2Jsb2NrLXByb2dyZXNzaW9uOnRiO2lzb2xhdGlvbjphdXRvO21peC1ibGVuZC1tb2RlOm5vcm1hbCIgZD0iTSAxOSA2IEMgMTguNTc1IDYgMTguMTk2NjQxIDYuMjY4OTIxOSAxOC4wNTY2NDEgNi42Njk5MjE5IEMgMTcuOTE2NjQxIDcuMDcwOTIxOSAxOC4wNDQ5NTMgNy41MTcyNSAxOC4zNzY5NTMgNy43ODEyNSBDIDE5LjE1NTk1MyA4LjQwMjI1IDE5LjY4OCA5LjE3ODM5MDYgMjAgMTAuMTUwMzkxIEwgMjAgMjYuNjg5NDUzIEwgMTAuMjQyMTg4IDQwLjg4MjgxMiBDIDkuODIyMTg3NSA0MS40OTM4MTIgOS43NzUxNDA2IDQyLjI4MDU0NyAxMC4xMTkxNDEgNDIuOTM1NTQ3IEMgMTAuNDY0MTQxIDQzLjU5MjU0NyAxMS4xNDA4MTMgNDQgMTEuODgyODEyIDQ0IEwgMzguMTE3MTg4IDQ0IEMgMzguODU5MTg3IDQ0IDM5LjUzNDkwNiA0My41OTE1NDcgMzkuODc4OTA2IDQyLjkzNTU0NyBDIDQwLjIyMzkwNiA0Mi4yODA1NDcgNDAuMTc3ODEyIDQxLjQ5MzgxMiAzOS43NTc4MTIgNDAuODgyODEyIEwgMzAgMjYuNjg5NDUzIEwgMzAgMTAuMDYwNTQ3IEMgMzAuMTMyIDkuMDE3NTQ2OSAzMC41ODM4OTEgOC4zNDU3MTg3IDMxLjQ2Mjg5MSA3Ljg4NjcxODggQyAzMS44NzA4OTEgNy42NzM3MTg3IDMyLjA4MTY1NiA3LjIwODcxODggMzEuOTcyNjU2IDYuNzYxNzE4OCBDIDMxLjg2MTY1NiA2LjMxMzcxODcgMzEuNDYxIDYgMzEgNiBMIDE5IDYgeiBNIDIxLjIwMzEyNSA4IEwgMjguNTc0MjE5IDggQyAyOC4yNzcyMTkgOC41NSAyOC4wODc4MTMgOS4xNzk3MTg3IDI4LjAwNzgxMiA5Ljg4NjcxODggQyAyOC4wMDI4MTMgOS45MjM3MTg3IDI4IDkuOTYyIDI4IDEwIEwgMjggMjcgQyAyOCAyNy4yMDIgMjguMDYxNzgxIDI3LjQwMDQwNiAyOC4xNzU3ODEgMjcuNTY2NDA2IEwgMzAuMzY1MjM0IDMwLjc1IEwgMTkuNjM0NzY2IDMwLjc1IEwgMjEuODI0MjE5IDI3LjU2NjQwNiBDIDIxLjkzNzIxOSAyNy40MDA0MDYgMjIgMjcuMjAyIDIyIDI3IEwgMjIgMTAgQyAyMiA5LjkwNCAyMS45ODU5ODQgOS44MDg3OTY5IDIxLjk1ODk4NCA5LjcxNjc5NjkgQyAyMS43NzU5ODQgOS4wOTY3OTY5IDIxLjUyMzEyNSA4LjUyNCAyMS4yMDMxMjUgOCB6IE0gNiAxNCBDIDUuNDQ3IDE0IDUgMTQuNDQ4IDUgMTUgTCA1IDIwLjMzMjAzMSBDIDEuOTY0IDIxLjczMzAzMSAwLjAyNCAyNC42NjkxODggMCAyNy45OTIxODggQyAtMC4wMTggMzAuNDE3MTg4IDAuOTExMjgxMjUgMzIuNjkyNDM4IDIuNjEzMjgxMiAzNC4zOTg0MzggQyA0LjI5MTI4MTIgMzYuMDc3NDM4IDYuNTM5MzEyNSAzNyA4Ljk0NTMxMjUgMzcgTCA5IDM3IEwgMTAuMjk0OTIyIDM3IEwgMTEuNjkzMzU5IDM1IEwgOC45OTQxNDA2IDM1IEwgOC45NTExNzE5IDM1IEMgNy4wNzQxNzE5IDM1IDUuMzI4Mjk2OSAzNC4yODUzNzUgNC4wMjkyOTY5IDMyLjk4NDM3NSBDIDIuNzA3Mjk2OSAzMS42NjAzNzUgMS45ODYgMjkuODkzODEyIDIgMjguMDA3ODEyIEMgMi4wMDUwOTIzIDI3LjMwNTU3NyAyLjExODM4ODQgMjYuNjMxMTUzIDIuMzI2MTcxOSAyNiBMIDE1Ljg0MTc5NyAyNiBDIDE1LjkzMDk5NCAyNi4zMzE1NyAxNS45OTI0NzMgMjYuNjcxMiAxNiAyNy4wMjE0ODQgQyAxNi4wMDYgMjcuMzE5NDg0IDE2LjAwMjk1MyAyOC40Mzc4NDQgMTYuMDAxOTUzIDI4LjgzOTg0NCBMIDE3LjkwMjM0NCAyNi4xMjEwOTQgQyAxNy40NTgzNDQgMjMuMzY3MDk0IDE1LjI2IDIxLjIwMzA2MiAxMyAyMC4yODkwNjIgTCAxMyAxNSBDIDEzIDE0LjQ0OCAxMi41NTMgMTQgMTIgMTQgTCA2IDE0IHogTSAzNCAxNCBDIDMzLjQ0NyAxNCAzMyAxNC40NDggMzMgMTUgTCAzMyAyMi44MzIwMzEgQSAxLjAwMDEgMS4wMDAxIDAgMCAwIDMzIDIzLjE1ODIwMyBMIDMzIDI3LjUzMTI1IEwgMzQuOTM5NDUzIDMwLjMwMjczNCBDIDM0Ljk3MDQ1MyAzMC4yMDU3MzQgMzUgMzAuMTA4IDM1IDMwIEwgMzUgMjQgTCA0NiAyNCBMIDQ2IDM1IEwgMzguMjIyNjU2IDM1IEwgMzkuNjIxMDk0IDM3IEwgNDcgMzcgQyA0Ny41NTMgMzcgNDggMzYuNTUyIDQ4IDM2IEwgNDggMjMuMTY3OTY5IEEgMS4wMDAxIDEuMDAwMSAwIDAgMCA0OCAyMi44NDE3OTcgTCA0OCAxOC4wMjkyOTcgQyA0OC4wMjUgMTcuMTg4Mjk3IDQ4LjYyOTUgMTYuMjkyNDM3IDQ5LjQzNzUgMTUuODk4NDM4IEMgNDkuODU1NSAxNS42OTQ0MzcgNTAuMDc4NjA5IDE1LjIyOTM5MSA0OS45NzQ2MDkgMTQuNzc1MzkxIEMgNDkuODY5NjA5IDE0LjMyMTM5MSA0OS40NjYgMTQgNDkgMTQgTCAzNCAxNCB6IE0gNyAxNiBMIDExIDE2IEwgMTEgMjEgQyAxMSAyMS40NDcgMTEuMjk2NTYzIDIxLjgzOTg5MSAxMS43MjY1NjIgMjEuOTYyODkxIEMgMTIuODI3NzI5IDIyLjI3NjEzNSAxMy45NDgyMDQgMjMuMDE2NDA5IDE0Ljc2OTUzMSAyNCBMIDMuNDQzMzU5NCAyNCBDIDQuMTc3NzQzNyAyMy4xMDE3ODcgNS4xNTQ3NzQ2IDIyLjM3OTc4OSA2LjM0NzY1NjIgMjEuOTM3NSBDIDYuNzM4NjU2MyAyMS43OTI1IDcgMjEuNDE4IDcgMjEgTCA3IDE2IHogTSAzNSAxNiBMIDQ2LjU2ODM1OSAxNiBDIDQ2LjIyNDM1OSAxNi42MTMgNDYuMDIgMTcuMzAxIDQ2IDE4IEwgNDYgMjIgTCAzNSAyMiBMIDM1IDE2IHogTSAxOC4yNTk3NjYgMzIuNzUgTCAzMS43NDAyMzQgMzIuNzUgTCAzOC4wOTk2MDkgNDIgTCAxMS44OTA2MjUgNDIuMDE1NjI1IEwgMTguMjU5NzY2IDMyLjc1IHoiIGZvbnQtd2VpZ2h0PSI0MDAiIGZvbnQtZmFtaWx5PSJzYW5zLXNlcmlmIiB3aGl0ZS1zcGFjZT0ibm9ybWFsIiBvdmVyZmxvdz0idmlzaWJsZSI+PC9wYXRoPjwvc3ZnPg=="
            />
          </b-col>
          <b-col cols="9" class="text-left dosage-form break-word">
            <h5>
              <editor
                :areaKey="'df'"
                v-model="instruction.dosageForm"
                :editable="user.isAdmin"
                :applyTextEditCallback="applyTextEdit"
                emptyLabel="[Doseringsform]"
              ></editor>
            </h5>
          </b-col>
        </b-row>
        <b-row class="justify-content-md-center" v-if="instruction.substance || user.isAdmin">
          <b-col cols="3" class="text-right">
            <img
              v-b-tooltip.hover.auto
              title="Verksam substans"
              src="data:image/svg+xml;base64,PHN2ZyB4bWxucz0iaHR0cDovL3d3dy53My5vcmcvMjAwMC9zdmciIHg9IjBweCIgeT0iMHB4IgogICAgIHdpZHRoPSI1MCIgaGVpZ2h0PSI1MCIKICAgICB2aWV3Qm94PSIwIDAgNTAgNTAiCiAgICAgc3R5bGU9IjtmaWxsOiMwMDAwMDA7IgogICAgIGNsYXNzPSJpY29uIGljb25zOC1tb2xlY3VsZSI+PGcgaWQ9InN1cmZhY2UxIj48cGF0aCBzdHlsZT0iICIgZD0iTSAxMiAwIEMgMTAuODk0NTMxIDAgMTAgMC44OTQ1MzEgMTAgMiBDIDEwIDMuMDkzNzUgMTAuODc4OTA2IDMuOTg0Mzc1IDExLjk2ODc1IDQgTCAxNi4zMTI1IDExLjk2ODc1IEMgMTYuMTI4OTA2IDEyLjI2OTUzMSAxNiAxMi42MjEwOTQgMTYgMTMgQyAxNiAxMy41NTA3ODEgMTYuMjMwNDY5IDE0LjA0Mjk2OSAxNi41OTM3NSAxNC40MDYyNSBMIDExLjkzNzUgMjMgQyAxMS4yMjI2NTYgMjMuMDIzNDM4IDEwLjYxNzE4OCAyMy40MjE4NzUgMTAuMjgxMjUgMjQgTCAzLjcxODc1IDI0IEMgMy4zNzEwOTQgMjMuNDAyMzQ0IDIuNzM4MjgxIDIzIDIgMjMgQyAwLjg5NDUzMSAyMyAwIDIzLjg5NDUzMSAwIDI1IEMgMCAyNi4xMDU0NjkgMC44OTQ1MzEgMjcgMiAyNyBDIDIuNzM4MjgxIDI3IDMuMzcxMDk0IDI2LjU5NzY1NiAzLjcxODc1IDI2IEwgMTAuMjgxMjUgMjYgQyAxMC42MTcxODggMjYuNTc4MTI1IDExLjIyMjY1NiAyNi45NzY1NjMgMTEuOTM3NSAyNyBMIDE2LjU5Mzc1IDM1LjU5Mzc1IEMgMTYuMjMwNDY5IDM1Ljk1NzAzMSAxNiAzNi40NDkyMTkgMTYgMzcgQyAxNiAzNy4zNzg5MDYgMTYuMTI4OTA2IDM3LjczMDQ2OSAxNi4zMTI1IDM4LjAzMTI1IEwgMTEuOTY4NzUgNDYgQyAxMC44Nzg5MDYgNDYuMDE1NjI1IDEwIDQ2LjkwNjI1IDEwIDQ4IEMgMTAgNDkuMTA1NDY5IDEwLjg5NDUzMSA1MCAxMiA1MCBDIDEzLjEwNTQ2OSA1MCAxNCA0OS4xMDU0NjkgMTQgNDggQyAxNCA0Ny42MjEwOTQgMTMuODcxMDk0IDQ3LjI2OTUzMSAxMy42ODc1IDQ2Ljk2ODc1IEwgMTguMDYyNSAzOSBDIDE4Ljc3NzM0NCAzOC45NzY1NjMgMTkuMzgyODEzIDM4LjU3ODEyNSAxOS43MTg3NSAzOCBMIDMwLjI4MTI1IDM4IEMgMzAuNjI4OTA2IDM4LjU5NzY1NiAzMS4yNjE3MTkgMzkgMzIgMzkgTCAzNS4xMjUgNDQuNSBDIDM1LjQwMjM0NCA0NC45ODQzNzUgMzYuMDE1NjI1IDQ1LjE1MjM0NCAzNi41IDQ0Ljg3NSBDIDM2Ljk4NDM3NSA0NC41OTc2NTYgMzcuMTUyMzQ0IDQzLjk4NDM3NSAzNi44NzUgNDMuNSBMIDMzLjcxODc1IDM4IEMgMzMuODkwNjI1IDM3LjcwNzAzMSAzNCAzNy4zNjMyODEgMzQgMzcgQyAzNCAzNi40NDkyMTkgMzMuNzY5NTMxIDM1Ljk1NzAzMSAzMy40MDYyNSAzNS41OTM3NSBMIDM4LjA2MjUgMjcgQyAzOC43NzczNDQgMjYuOTc2NTYzIDM5LjM4MjgxMyAyNi41NzgxMjUgMzkuNzE4NzUgMjYgTCA0Ni4yODEyNSAyNiBDIDQ2LjYyODkwNiAyNi41OTc2NTYgNDcuMjYxNzE5IDI3IDQ4IDI3IEMgNDkuMTA1NDY5IDI3IDUwIDI2LjEwNTQ2OSA1MCAyNSBDIDUwIDIzLjg5NDUzMSA0OS4xMDU0NjkgMjMgNDggMjMgQyA0Ny4yNjE3MTkgMjMgNDYuNjI4OTA2IDIzLjQwMjM0NCA0Ni4yODEyNSAyNCBMIDM5LjcxODc1IDI0IEMgMzkuMzc4OTA2IDIzLjQxMDE1NiAzOC43NTc4MTMgMjMuMDExNzE5IDM4LjAzMTI1IDIzIEwgMzMuNDA2MjUgMTQuNDA2MjUgQyAzMy43Njk1MzEgMTQuMDQyOTY5IDM0IDEzLjU1MDc4MSAzNCAxMyBDIDM0IDEyLjYyMTA5NCAzMy44NzEwOTQgMTIuMjY5NTMxIDMzLjY4NzUgMTEuOTY4NzUgTCAzOC4wMzEyNSA0IEMgMzguNzU3ODEzIDMuOTg4MjgxIDM5LjM3ODkwNiAzLjU4OTg0NCAzOS43MTg3NSAzIEwgNDkgMyBDIDQ5LjM1OTM3NSAzLjAwMzkwNiA0OS42OTUzMTMgMi44MTY0MDYgNDkuODc4OTA2IDIuNTAzOTA2IEMgNTAuMDU4NTk0IDIuMTkxNDA2IDUwLjA1ODU5NCAxLjgwODU5NCA0OS44Nzg5MDYgMS40OTYwOTQgQyA0OS42OTUzMTMgMS4xODM1OTQgNDkuMzU5Mzc1IDAuOTk2MDk0IDQ5IDEgTCAzOS43MTg3NSAxIEMgMzkuMzcxMDk0IDAuNDAyMzQ0IDM4LjczODI4MSAwIDM4IDAgQyAzNi44OTQ1MzEgMCAzNiAwLjg5NDUzMSAzNiAyIEMgMzYgMi4zNzg5MDYgMzYuMTI4OTA2IDIuNzMwNDY5IDM2LjMxMjUgMy4wMzEyNSBMIDMxLjkzNzUgMTEgQyAzMS4yMjI2NTYgMTEuMDIzNDM4IDMwLjYxNzE4OCAxMS40MjE4NzUgMzAuMjgxMjUgMTIgTCAxOS43MTg3NSAxMiBDIDE5LjM3ODkwNiAxMS40MTAxNTYgMTguNzU3ODEzIDExLjAxMTcxOSAxOC4wMzEyNSAxMSBMIDEzLjY4NzUgMy4wMzEyNSBDIDEzLjg3MTA5NCAyLjczMDQ2OSAxNCAyLjM3ODkwNiAxNCAyIEMgMTQgMC44OTQ1MzEgMTMuMTA1NDY5IDAgMTIgMCBaIE0gMTkuNzE4NzUgMTQgTCAzMC4yODEyNSAxNCBDIDMwLjUzMTI1IDE0LjQyOTY4OCAzMC45MjE4NzUgMTQuNzU3ODEzIDMxLjQwNjI1IDE0LjkwNjI1IEwgMzYuMzEyNSAyMy45Mzc1IEMgMzYuMTIxMDk0IDI0LjI0NjA5NCAzNiAyNC42MDkzNzUgMzYgMjUgQyAzNiAyNS4zOTA2MjUgMzYuMTIxMDk0IDI1Ljc1MzkwNiAzNi4zMTI1IDI2LjA2MjUgTCAzMS40MDYyNSAzNS4wOTM3NSBDIDMwLjkyMTg3NSAzNS4yNDIxODggMzAuNTMxMjUgMzUuNTcwMzEzIDMwLjI4MTI1IDM2IEwgMTkuNzE4NzUgMzYgQyAxOS40Njg3NSAzNS41NzAzMTMgMTkuMDc4MTI1IDM1LjI0MjE4OCAxOC41OTM3NSAzNS4wOTM3NSBMIDEzLjY4NzUgMjYuMDYyNSBDIDEzLjg3ODkwNiAyNS43NTM5MDYgMTQgMjUuMzkwNjI1IDE0IDI1IEMgMTQgMjQuNjA5Mzc1IDEzLjg3ODkwNiAyNC4yNDYwOTQgMTMuNjg3NSAyMy45Mzc1IEwgMTguNTkzNzUgMTQuOTA2MjUgQyAxOS4wNzgxMjUgMTQuNzU3ODEzIDE5LjQ2ODc1IDE0LjQyOTY4OCAxOS43MTg3NSAxNCBaICI+PC9wYXRoPjwvZz48L3N2Zz4="
            />
          </b-col>
          <b-col cols="9" class="text-left substance break-word">
            <h5>
              <editor
                :areaKey="'sub'"
                v-model="instruction.substance"
                :editable="user.isAdmin"
                :applyTextEditCallback="applyTextEdit"
                emptyLabel="[Substans]"
              ></editor>
            </h5>
          </b-col>
        </b-row>
        <hr />
      </div>
      <div class="detailed-info text-left">
        <div>
          <b-row v-if="generalInstructions.text || user.idAdmin">
            <b-col>
              <h4>Kunskapsunderlag vid spädning av läkemedel</h4>
              <a href="javascript:void(0)" v-b-toggle.collapse1 variant="primary">
                Generella anvisningar
                <i class="fa fa-angle-down"></i>
              </a>
              <b-collapse id="collapse1" class="mt-2">
                <div>
                  <editor
                    :areaKey="'gi'"
                    v-model="generalInstructions.text"
                    :editable="user.isAdmin"
                    :applyTextEditCallback="applyTextEditContent"
                    emptyLabel="[Generella anvisningar]"
                  ></editor>
                </div>
              </b-collapse>
            </b-col>
          </b-row>
        </div>
        <b-row>
          <b-col>
            <div role="tablist">
              <b-card
                no-body
                class="mb-1"
                v-for="(info, index) in instruction.dilutionInfos"
                v-bind:key="index"
              >
                <b-card-header header-tag="header" class="p-1" role="tab">
                  <b-btn
                    block
                    href="#"
                    v-b-toggle="'accordion' + index"
                    variant="dilution"
                    class="text-left"
                  >
                    <editor
                      :areaKey="'am'"
                      v-model="info.administrationMethod"
                      :editable="user.isAdmin"
                      :applyTextEditCallback="applyTextEdit"
                      emptyLabel="[Administreringsmetod]"
                      class="d-inline"
                    ></editor>
                    {{ info.amount ? '-' : '' }}
                    <editor
                      :areaKey="'amount'"
                      v-model="info.amount"
                      :editable="user.isAdmin"
                      :applyTextEditCallback="applyTextEdit"
                      emptyLabel="[Mängd]"
                      class="d-inline"
                    ></editor>
                    <i class="fa fa-angle-up fa-2x when-opened" style="float: right;" />
                    <i class="fa fa-angle-down fa-2x when-closed" style="float: right;" />
                  </b-btn>
                </b-card-header>
                <b-collapse :id="'accordion' + index" accordion="my-accordion" role="tabpanel">
                  <b-card-body>
                    <div class="card-text">
                      <b>Spädningsinstruktion</b>
                      <div>
                        <editor
                          :areaKey="'si'"
                          v-model="info.dilutionInstruction"
                          :editable="user.isAdmin"
                          :applyTextEditCallback="applyTextEdit"
                          emptyLabel="[Spädningsinstruktion]"
                        ></editor>
                      </div>
                    </div>
                    <br />
                    <div class="card-text">
                      <b>Administreringstid</b>
                      <div>
                        <editor
                          :areaKey="'at'"
                          v-model="info.administrationTime"
                          :editable="user.isAdmin"
                          :applyTextEditCallback="applyTextEdit"
                          emptyLabel="[Administreringstid]"
                        ></editor>
                      </div>
                    </div>
                    <b-row v-if="user.isAdmin">
                      <b-col sm="12">
                        <mu-raised-button
                          class="demo-raised-button"
                          label="Ta bort spädningsinfo"
                          icon="remove"
                          primary
                          @click="openConfirmDialog($event, index)"
                        />
                        <hr />
                      </b-col>
                    </b-row>
                  </b-card-body>
                </b-collapse>
              </b-card>
            </div>
            <b-row v-if="user.isAdmin">
              <b-col sm="12">
                <mu-raised-button
                  class="demo-raised-button"
                  label="Lägg till spädningsinfo"
                  icon="add"
                  primary
                  @click="addDilutionInfo"
                />
                <hr />
              </b-col>
            </b-row>
          </b-col>
        </b-row>
        <b-row v-if="instruction.remark || user.isAdmin">
          <b-col>
            <h4>Observandum</h4>
            <p>
              <editor
                :areaKey="'rem'"
                v-model="instruction.remark"
                :editable="user.isAdmin"
                :applyTextEditCallback="applyTextEdit"
                emptyLabel="[Observandum]"
              ></editor>
            </p>
          </b-col>
        </b-row>
        <b-row v-if="instruction.modifiedDate">
          <b-col>
            <modified-date :date="instruction.modifiedDate" />
          </b-col>
        </b-row>
      </div>
    </b-container>
    <mu-dialog :open="confirmDialog" title="Bekräfta" @close="closeConfirmDialog">
      Är du säker på att du vill fortsätta?
      <mu-flat-button slot="actions" @click="genericDelete" primary label="Ja" />
      <mu-flat-button slot="actions" primary @click="closeConfirmDialog" label="Avbryt" />
    </mu-dialog>
  </div>
</template>

<script>
import {
  updateDilution,
  deleteDilution,
  updateContent
} from '../store/actions'

export default {
  name: 'Dilution',
  data () {
    return {
      confirmDialog: false,
      dilutionInfoIndex: null
    }
  },
  mounted () {
    window.scrollTo(0, 0)
  },
  props: ['id'],
  computed: {
    instruction () {
      let item = this.$store.getters.dilutionById(this.id)
      return item || {}
    },
    generalInstructions () {
      let item = this.$store.getters.contentByKey('Dilution')
      if (!item) return ''
      return item || ''
    },
    user () {
      return this.$store.state.user
    }
  },
  methods: {
    applyTextEdit () {
      this.save()
    },
    applyTextEditContent () {
      updateContent(this.$store, this.generalInstructions)
    },
    save () {
      updateDilution(this.$store, this.instruction)
    },
    deleteDilution () {
      deleteDilution(this.$store, this.instruction)
    },
    addDilutionInfo () {
      if (!this.instruction.dilutionInfos) {
        this.instruction.dilutionInfos = []
      }
      this.instruction.dilutionInfos.push({
        administrationMethod: '',
        administrationTime: '',
        amount: '',
        dilutionInstruction: ''
      })
      this.save()
    },
    deleteDilutionInfo (index) {
      this.instruction.dilutionInfos.splice(index, 1)
      this.save()
    },
    genericDelete () {
      if (this.dilutionInfoIndex >= 0) {
        this.deleteDilutionInfo(this.dilutionInfoIndex)
      } else {
        this.deleteDilution()
      }
      this.closeConfirmDialog()
    },
    openConfirmDialog (event, dilutionInfoIndex) {
      this.dilutionInfoIndex = dilutionInfoIndex
      this.confirmDialog = true
    },
    closeConfirmDialog () {
      this.confirmDialog = false
    },
    togglePublish () {
      this.instruction.isPublished = !this.instruction.isPublished
      updateDilution(this.$store, this.instruction)
    }
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped lang="scss">
h1,
h2 {
  font-weight: normal;
}

.name-info {
  padding: .5em 0;
  font-weight: bold;

  .npl-title {
    font-weight: bold;
  }

  .npl-id {
    margin-bottom: 0;
    padding: 0 0.5em;
    white-space: nowrap;
    color: $turkos;
  }

  h1 {
    margin-top: 0;
  }

  .low-margin-bottom {
    margin-bottom: 0.4em;
  }
}

.quick-info {
  img {
    width: 40px;
  }
  h5 {
    margin-bottom: 0;
  }
}

.detailed-info {
  .row {
    padding-top: 30px;
  }

  p {
    display: inline;
  }
}

.item + .item:before {
  content: ", ";
}

.substance,
.dosage-form {
  margin-top: 8px;
}

.section-name {
  color: white;
  margin: 0;
  font-weight: bold;
  font-size: 25pt;
  text-shadow: 0 0 10px #888;
}

.section-image {
  padding-top: 25px;
  top: 70px;
  z-index: -1;
  height: 95px;
  width: 100%;
  background-image: url("../assets/dilution-background.jpg");
  background-position-y: bottom;
  background-size: cover;
}

body .view-container {
  padding-top: 40px;
}

.collapsed > .when-opened,
:not(.collapsed) > .when-closed {
  display: none;
}

.fa.when-opened,
.fa.when-closed {
  margin-top: -4px;
}
</style>
